<template>
    <div v-if="tweetUser">
        <div class="mb-3">
            <h2>User profile</h2>

            <div class="row">
                <div class="col-12">
                    <img :src="tweetUser.image_src" class="m-3" style="border-radius: 50%;"/>
                </div>
            </div>
            <div v-for="(itemValue, itemName) in tweetUser.profile_items " class="row">
                <div class="col-5 t">
                    <strong>{{ itemName }}</strong>
                </div>
                <div class="col-7">
                    {{ itemValue }}
                </div>
            </div>
        </div>
        <tweet-user-additional-data></tweet-user-additional-data>
    </div>
</template>

<script>
    import TweetUserAdditionalData from "./TweetUserAdditionalData";
    export default {
        name: "TweetUserProfile",
        components: {TweetUserAdditionalData},
        props:{
            tweetUser: {
                type: Object,
                default: null
            }
        },

    }
</script>

<style scoped>

</style>
